export default "__VITE_ASSET__bdae96f1__"